import styled from '@emotion/styled';
import { ButtonLegacy, StyledResetButton } from '~/shared/components/_Button';

export const StyledDropdownContainer = styled.div(({ theme }) => ({
    height: theme.spaces[5],
    position: 'relative',
    display: 'inline-block',
}));

export const StyledDropdownTrigger = styled(StyledResetButton)<{ isOpen: boolean }>(
    ({ theme, isOpen }) => ({
        height: theme.spaces[5],
        fontFamily: theme.fonts.body,
        fontSize: theme.fontSizes.sm,
        padding: `0 ${theme.spaces[2]} 2px`, // Padding Bottom 2px because of border 2px except in bottom, causes a desalignment with other items
        border: `2px solid ${isOpen ? theme.colors.dark : 'transparent'}`,
        borderBottom: `none`,
        ['&:focus']: {
            outline: `2px solid ${theme.colors.blue20}`,
        },
        '& svg': {
            pointerEvents: 'none',
        },
    })
);

export const StyledDropdownTriggerAsSecondaryButton = styled(ButtonLegacy)<{
    isOpen: boolean;
    isLoading?: boolean;
}>(({ theme, isOpen, isLoading }) => ({
    border: `2px solid ${isOpen ? theme.colors.dark : 'transparent'}`,
    color: isLoading ? 'transparent' : undefined,
    '& svg': {
        pointerEvents: 'none',
    },
}));

export const StyledDropdownTitle = styled.label(({ theme }) => ({
    marginRight: theme.spaces[2],
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.sm,
    cursor: 'pointer',
}));

export const StyledDropdownList = styled.ul(({ theme }) => ({
    zIndex: theme.zIndices[1],
    position: 'absolute',
    backgroundColor: theme.colors.light,
    border: `2px solid ${theme.colors.dark}`,
    minWidth: '100%',
    maxHeight: '200px',
    overflowY: 'auto',
}));

export const StyledListItem = styled.li(({ theme }) => ({
    ['&:hover']: {
        backgroundColor: theme.colors.light30,
    },
    ['&:focus']: {
        outline: 'none',
        backgroundColor: theme.colors.light30,
    },
    cursor: 'pointer',
}));

export const StyledListOption = styled.span<{ isSelected: boolean }>(({ theme, isSelected }) => ({
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.sm,
    fontWeight: isSelected ? theme.fontWeights.medium : theme.fontWeights.regular,
    padding: `0 ${theme.spaces[2]}`,
    minWidth: '100%',
    flex: 1,
    display: 'flex',
    minHeight: theme.spaces[5],
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ['&:focus']: {
        outline: 'none',
        backgroundColor: theme.colors.light30,
    },
}));
